import { Council } from 'types';

export const getCouncilAttendanceText = (council: Council): string => {
  const participants = council?.participants?.length || 0;
  const assistants =
    council?.participants?.filter((participant) => participant.assists)
      ?.length || 0;

  return `${assistants}/${participants}`;
};
